export function boolTransform(arg: string) {
  return arg === 'true';
}

export type TEnvOverrideConfig = [
  // Key of config value
  string | undefined,
  // Path in env object to set the value to
  string | string[],
  // Transform function, to transform string to array, object, etc.
  ((value: string) => unknown) | undefined,
][];

export const ENV_LIST_MAP: TEnvOverrideConfig = [
  [process.env.REACT_APP_INSTANCE_TYPE, 'instance', String],
  // App override
  [process.env.REACT_APP_WEEK_STARTS_ON, 'app.weekStartsOn', Number],
  [process.env.REACT_APP_SHOW_TOOLS_TAB, 'app.showTools', boolTransform],
  [process.env.REACT_APP_IS_ADAM, 'app.isCompact', boolTransform],
  // Auth override
  [process.env.REACT_APP_AUTH_API_URL, 'auth.authUri', String],
  [process.env.REACT_APP_NEW_AUTH_API_URL, 'auth.authUri', String],
  [process.env.REACT_APP_API_KEY, 'auth.apiKey', String],
  [process.env.REACT_APP_NEW_API_KEY, 'auth.apiKey', String],
  // Api
  [process.env.REACT_APP_TRANSLATIONS_API_URL, 'api.translationApiUri', String],
  [process.env.REACT_APP_MEMBER_API_URL, 'api.memberApiUri', String],
  [process.env.REACT_APP_MEMBER_API_URL_V2, 'api.memberApiV2Uri', String],
  // XMPP
  [process.env.REACT_APP_XMPP_SERVER_URI, 'xmpp.serverUri', String],
  [process.env.REACT_APP_XMPP_MUC_SERVER_URI, 'xmpp.conferenceUri', String],
  [process.env.REACT_APP_HILBI_UID, 'xmpp.hilbiId', String],
  [process.env.REACT_APP_HILBI_JID, 'xmpp.hilbiJid', String],
  // Support
  [process.env.REACT_APP_SUPPORT_WIDGET_BASE, 'support.baseUri', String],
  [process.env.REACT_APP_SUPPORT_WIDGET_TOKEN, 'support.token', String],
];
